import { Resource, Condition } from '@medplum/fhirtypes'
import { formatDateTime } from '@/utils'

type Props = {
  resource?: Resource
}

const availFields = [
  { code: 'description', title: 'Description' },
  { code: 'type', title: 'Type' },
  { code: 'icd10', title: 'ICD-10-CM' },
  { code: 'snomed', title: 'SNOMED CT®' },
  { code: 'clinical-status', title: 'Status' },
  { code: 'onset-date', title: 'Started' },
  { code: 'ended', title: 'Ended' },
  { code: 'doctor', title: 'Doctor' },
]

const getCode = (condition: Condition, system: string) => {
  return (
    condition.code?.coding?.find((c) => c.system?.includes(system))?.code ||
    condition.code?.coding?.find((c) => c.system?.toLowerCase().includes(system))?.code ||
    '-'
  )
}

const renderColumn = (condition: Condition, itemCode: string) => {
  switch (itemCode) {
    case 'description':
      return condition.code?.text || condition.code?.coding?.[0]?.display || '-'
    case 'type':
      return condition.category?.[0]?.coding?.[0]?.display || 'Diagnosis'
    case 'icd10':
      return getCode(condition, 'icd-10')
    case 'snomed':
      return getCode(condition, 'snomed')
    case 'clinical-status':
      return condition.clinicalStatus?.coding?.[0]?.code || '-'
    case 'onset-date':
      return condition.onsetDateTime || condition.onsetPeriod?.start
        ? formatDateTime(condition.onsetDateTime || condition.onsetPeriod?.start || '')
        : '-'
    case 'ended':
      return condition.abatementDateTime || condition.onsetPeriod?.end
        ? formatDateTime(condition.abatementDateTime || condition.onsetPeriod?.end || '')
        : '-'
    case 'doctor':
      return condition.asserter?.display || '-'
    default:
      return ''
  }
}

export function Diagnoses({ resource }: Props) {
  const condition = resource as Condition

  if (!condition) {
    return null
  }

  return (
    <div className="border-b-1 border-b-gray-200 pb-2">
      <table className="text-base">
        <tbody>
          {availFields.map((item) => (
            <tr>
              <td className="py-1 text-sm font-bold text-[#7D7987]">{item.title}:</td>
              <td className="px-[8px] py-1 text-base text-sm">
                <div>{renderColumn(condition, item.code)}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
